import { datadogRum } from '@datadog/browser-rum';
import { getDefaultConfig } from 'Utils/Store';

let disableDataDog = false;

const initDataDogRum = () => {
  const { dataDogApplicationId, dataDogClientToken, appEnv, nodeEnv, appVersion, buildInfo } = getDefaultConfig();

  if (nodeEnv === 'development') {
    //comment out this next line if want DD to run on local
    disableDataDog = true;
    return;
  }

  /* version must exactly match version in dataDogUploadSourceMap.js script
  for sourcemap to work correctly */
  let version = '';

  //want to distinguish local - sourcemaps don't work with it
  if (nodeEnv === 'development') {
    version = `${appVersion}-local`;
    //prod uses just the version - changes every time semantic release adds a commit
  } else if (appEnv === 'production') {
    version = appVersion;
    //for qa and staging
  } else {
    version = buildInfo;
  }

  datadogRum.init({
    applicationId: dataDogApplicationId,
    clientToken: dataDogClientToken,
    site: 'datadoghq.com',
    env: appEnv,
    service: 'fox-nation-commerce',
    version,
    sampleRate: 100,
    premiumSampleRate: 100,
    trackInteractions: true,
    /*
    This is the default privacy level.
    Also can allow visibility of fields by adding data-dd-privacy="allow" to the element or its comtainer.
    Disallow visibility of elements by adding data-dd-privacy="mask" to the element.
    We want DD to not collect or show any user-specific data.
    */
    defaultPrivacyLevel: 'mask-user-input',
  });
  datadogRum.startSessionReplayRecording();
};

// helpers
const getActionName = (name = '', suffix = '') => {
  const upperCase = `${name} ${suffix}`.trim().toUpperCase();
  const actionName = upperCase.replace(/\s/g, '_');
  return actionName;
};

const setCustomAttribute = (name, val) => {
  if (disableDataDog) return;
  datadogRum.setGlobalContextProperty(name, val);
};

const addAction = (actionName, data) => {
  if (disableDataDog) return;
  datadogRum.addAction(actionName, data);
};

// exports
export const logError = (error, actionName = '', data = {}) => {
  if (disableDataDog) return;
  console.error(error);
  datadogRum.addError(error, { actionName, ...data });
};

export const logger = {
  init: initDataDogRum,
  setAttr: (name, val) => setCustomAttribute(name, val),
  started: (name, data) => {
    const actionName = getActionName(name, 'started');
    addAction(actionName, data);
  },
  completed: (name, data) => {
    const actionName = getActionName(name, 'completed');
    addAction(actionName, data);
  },
  error: (name, data, error) => {
    const actionName = getActionName(name, 'error');
    logError(error, actionName, data);
  },
  apiRequest: (name, data) => {
    const actionName = getActionName(name, 'api request');
    addAction(actionName, data);
  },
  apiResponse: (name, data) => {
    const actionName = getActionName(name, 'api response');
    addAction(actionName, data);
  },
  apiError: (name, data = {}, error = {}) => {
    const actionName = getActionName(name, 'api error');
    logError(error, actionName, { error, data });
  },
};
